<template>
  <div class="faka-detail">
    <nav-header v-if="$route.name=='fakaDetail'" />
    <el-card class="detail-card">
      <div class="product-info">
        <!-- 左侧商品图片 -->
        <div class="product-left">
          <el-carousel 
            v-if="product.images"
            height="400px"
            class="product-images"
            trigger="click"
            indicator-position="outside"
          >
            <el-carousel-item v-for="(img, index) in product.images.split(',')" :key="index">
              <el-image 
                :src="img"
                fit="cover"
                :preview-src-list="product.images.split(',')"
                @click="handlePreview(index)"
              />
            </el-carousel-item>
          </el-carousel>
        </div>

        <!-- 右侧商品信息 -->
        <div class="product-right">
          <!-- 卖家信息 -->
          <div class="seller-info">
            <div class="seller-avatar">
              <el-avatar 
                :size="50" 
                :src="userInfo.headImageThumb"
              />
            </div>
            <div class="seller-detail">
              <div class="seller-name">{{userInfo.nickName}}</div>
              <div class="seller-stats">
                <i style="font-size: 1.5rem" class="el-icon-chat-dot-round" @click="ifShow" ref="item"></i>
              </div>
            </div>
          </div>

          <el-divider></el-divider>
          
          <h2 class="product-title">{{product.name}}</h2>
          
          <div class="product-meta">
            <div class="price">¥ {{product.price}}</div>
            <div class="stats">
              <span>库存: {{product.stock}}</span>
              <span>销量: {{product.soldCount}}</span>
            </div>
          </div>

          <!-- 购买数量 -->
          <div class="purchase-amount">
            <span class="label">购买数量</span>
            <el-input-number
              v-model="buyAmount"
              :min="1"
              :max="product.stock"
              size="small"
              @change="handleAmountChange"
            />
          </div>

          <!-- 总价展示 -->
          <div class="total-price">
            <span class="label">总价</span>
            <span class="amount">¥ {{totalPrice}}</span>
          </div>

          <!-- 购买按钮 -->
          <div v-if="!hasPay" class="purchase-box">
            <el-button 
              type="primary" 
              size="large"
              :disabled="product.stock <= 0"
              @click="handlePurchase"
              class="buy-btn"
            >
              {{product.stock > 0 ? '立即购买' : '暂无库存'}}
            </el-button>
          </div>
        </div>
      </div>

      <!-- 商品详情 -->
      <div class="detail-content">
        <el-tabs type="border-card">
          <el-tab-pane label="商品描述">
            <div class="product-desc">
              <p>{{product.description}}</p>
            </div>
          </el-tab-pane>
          
          <el-tab-pane label="使用说明">
            <div class="product-instructions">
              <p>{{product.instructions}}</p>
            </div>
          </el-tab-pane>

          <!-- 已购买显示卡密 -->
          <el-tab-pane label="我的卡密" v-if="hasPay">
            <div class="card-list">
              <div class="section-title">
                <small class="warning-text">请及时保存您的卡密信息</small>
              </div>

              <el-table :data="product.klFakaCardVos" border stripe>
                <el-table-column label="卡密内容" prop="content">
                  <template slot-scope="scope">
                    <div class="card-content">
                      <span class="card-text">{{scope.row.content}}</span>
                      <el-tooltip content="点击复制" placement="top" :hide-after="1000">
                        <el-button 
                          type="text"
                          size="small"
                          class="copy-btn"
                          @click="copyCard(scope.row.content)"
                        >
                          <i class="el-icon-document-copy"></i>
                          复制
                        </el-button>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column 
                  label="购买时间"
                  prop="useTime"
                  width="180"
                />
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <comments-section v-if="product.createBy" bus-type="faka" :target-user-id="product.createBy" :target-id="$route.params.id"></comments-section>
    </el-card>
    <!-- 支付弹窗 -->
    <Pay ref="pay" @paySuccess="paySuccess"></Pay>
    <UserInfo ref="user" ></UserInfo>
    <!-- 图片预览组件 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="product.images.split(',')"
      :initial-index="currentImageIndex"
    />
  </div>
</template>

<script>
import Pay from "@/components/common/Pay.vue";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import UserInfo from "@/components/common/UserInfo.vue";
import NavHeader from "@/components/layout/NavHeader.vue";
import VueClipboard from 'vue-clipboard2'
import Vue from 'vue'
import CommentsSection from "@/components/common/comments-section.vue";

Vue.use(VueClipboard)

const isMobileDevice=() =>{
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 检查用户代理字符串
  return /android|iPhone|iPad|iPod|windows phone|blackberry|iemobile|opera mini/i.test(userAgent);
}
export default {
  components: {CommentsSection, NavHeader, UserInfo, Pay, ElImageViewer},
  data() {
    return {
      pos: {
        x: '60',
        y: '20',
      },
      showUser:true,
      product: {},
      cardList: [],
      hasPay: false,
      payDialogVisible: false,
      selectedPayMethod: 'alipay',
      payMethods: [
        {
          label: '支付宝',
          value: 'alipay',
          icon: '/static/image/alipay.png'
        },
        {
          label: '微信支付',
          value: 'wxpay',
          icon: '/static/image/wxpay.png'
        }
      ],
      buyAmount: 1, // 购买数量
      showViewer: false,
      currentImageIndex: 0,
      imageList: [],
      userInfo: {},
    }
  },

  computed: {
    totalPrice() {
      return (this.product.price * this.buyAmount).toFixed(2)
    },
    hasLogin(){
      return this.userStore?.userInfo.id ||sessionStorage.getItem("accessToken")
    }
  },

  methods: {
    ifShow(){
      if(!this.hasLogin)
      {
        window.$showLogin({
          success: () => {
            console.log("登录成功")
          },
          cancel: () =>{
            console.log("登录cancel")
          }
        });
        return
      }
      let left = this.$elm.fixLeft(this.$refs.item);
      let top = this.$elm.fixTop(this.$refs.item);
      let pos = {
        x: left + 50,
        y: top
      };
      this.$refs.user.open(this.userInfo,pos)
    },
    paySuccess(mchOrderNo){
      this.$http2({
        url: `/pay/getConent?mchOrderNo=${mchOrderNo}`,
        method: 'get'
      }).then((res) => {
        this.product=res.data;
        this.hasPay=true;
        this.loadUserInfo(this.product.createBy);
        if(!this.hasLogin)
          localStorage.setItem(this.product.id,mchOrderNo);
      })
    },
    loadUserInfo(userId) {
      this.$http2({
        url: `/im/user/${userId}`,
        method: 'get'
      }).then((user) => {
        this.userInfo = user.data;
      })
    },
    async loadDetail() {
      try {
        const res = await this.$http2({
          url: `/klgeek/fakaProduct/preview/${this.$route.params.id}`,
          method: 'get'
        })
        this.product = res.data
        this.loadUserInfo(this.product.createBy);
      } catch(e) {
        this.$message.error('加载商品详情失败')
      }
    },

    async loadCards() {
      try {
        const res = await this.$http2({
          url: `/klgeek/fakaCard/list?productId=${this.$route.params.id}`,
          method: 'get'
        })
        this.cardList = res.rows || []
      } catch(e) {
        this.$message.error('加载卡密列表失败')
      }
    },

    handlePreview(index) {
      this.currentImageIndex = index
      this.showViewer = true
    },

    closeViewer() {
      this.showViewer = false
    },

    copyCard(content) {
      this.$copyText(content).then(() => {
        this.$message({
          message: '复制成功',
          type: 'success',
          duration: 1500,
          offset: 80,
          customClass: 'copy-message'
        })
      }).catch(() => {
        this.$message({
          message: '复制失败,请手动复制',
          type: 'error',
          duration: 1500,
          offset: 80
        })
      })
    },

    handlePurchase() {
      this.$refs.pay.openPay(this.product.id,"faka",this.buyAmount);
    },

    handleAmountChange(val) {
      this.buyAmount = val
    },

    async confirmPay() {
      try {
        const res = await this.$http2({
          url: '/klgeek/faka/order/create',
          method: 'post',
          data: {
            productId: this.product.id,
            payMethod: this.selectedPayMethod,
            amount: this.buyAmount // 添加购买数量
          }
        })
        if(res.success) {
          this.$message.success('支付成功')
          this.payDialogVisible = false
          this.hasPay = true
          await this.loadCards()
        }
      } catch(e) {
        this.$message.error('支付失败')
      }
    }
  },

  created() {
    if(isMobileDevice()) location.href= process.env["VUE_APP_SHARE_BASE"]+"/h5/#/pages/creation/faka-detail?id="+this.$route.params.id;
    if( this.$route.query.mchOrderNo){
      this.paySuccess(this.$route.query.mchOrderNo)
      return;
    }
    if(this.$route.params.id){
      this.loadDetail()
    }
  }
}
</script>

<style lang="scss" scoped>
.faka-detail {
  padding: 20px;
  
  .detail-card {
    max-width: 1200px;
    margin: 0 auto;
  }

  .product-info {
    display: flex;
    margin-bottom: 30px;
    
    .product-left {
      width: 500px;
      margin-right: 40px;
      
      .product-images {
        border-radius: 8px;
        overflow: hidden;
        
        .el-image {
          width: 100%;
          height: 100%;
          cursor: zoom-in;
        }
      }
    }
    
    .product-right {
      flex: 1;
      padding: 20px;
      
      .seller-info {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding: 15px;
        background: #f8f9fa;
        border-radius: 8px;
        
        .seller-avatar {
          margin-right: 15px;
        }
        
        .seller-detail {
          .seller-name {
            font-size: 16px;
            font-weight: 500;
            color: #303133;
            margin-bottom: 5px;
          }
          
          .seller-stats {
            font-size: 13px;
            color: #909399;
            
            span {
              margin-right: 15px;
              
              &:last-child {
                margin-right: 0;
              }
            }
          }
        }
      }

      .el-divider {
        margin: 20px 0;
      }
      
      .product-title {
        font-size: 24px;
        margin-bottom: 20px;
        line-height: 1.4;
      }
      
      .product-meta {
        margin-bottom: 30px;
        padding: 20px;
        background: #f8f9fa;
        border-radius: 8px;
        
        .price {
          font-size: 32px;
          color: #f56c6c;
          font-weight: bold;
          margin-bottom: 15px;
        }
        
        .stats {
          color: #909399;
          
          span {
            margin-right: 20px;
          }
        }
      }
      
      .purchase-amount {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        
        .label {
          width: 70px;
          color: #606266;
          font-size: 14px;
        }
      }
      
      .total-price {
        margin-bottom: 30px;
        
        .label {
          font-size: 14px;
          color: #909399;
          margin-right: 10px;
        }
        
        .amount {
          font-size: 24px;
          color: #f56c6c;
          font-weight: bold;
        }
      }
      
      .purchase-box {
        .buy-btn {
          width: 180px;
          height: 50px;
          font-size: 18px;
        }
      }
    }
  }

  .detail-content {
    .product-desc,
    .product-instructions {
      padding: 20px;
      
      p {
        color: #606266;
        line-height: 1.8;
        margin: 0;
      }
    }
  }

  .card-list {
    padding: 20px;
    
    .section-title {
      margin-bottom: 20px;
      
      .warning-text {
        color: #f56c6c;
      }
    }
    
    .card-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 0;

      .card-text {
        flex: 1;
        margin-right: 15px;
        word-break: break-all;
        color: #606266;
      }

      .copy-btn {
        padding: 4px 12px;
        transition: all 0.3s;
        border-radius: 4px;
        
        &:hover {
          color: #409EFF;
          background: rgba(64,158,255,0.1);
        }
        
        &:active {
          transform: scale(0.95);
        }
        
        i {
          margin-right: 4px;
          font-size: 14px;
        }
      }
    }
  }

  .pay-dialog {
    .pay-info {
      margin-bottom: 20px;
      
      .info-item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        
        .label {
          color: #909399;
        }
        
        &.total {
          margin-top: 15px;
          padding-top: 15px;
          border-top: 1px solid #eee;
          
          .amount {
            font-size: 20px;
            color: #f56c6c;
            font-weight: bold;
          }
        }
      }
    }
    
    .pay-methods {
      display: flex;
      justify-content: space-around;
      margin-bottom: 20px;
      
      .pay-method-item {
        padding: 15px 25px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;
        
        &:hover {
          border-color: #409EFF;
        }
        
        &.active {
          border-color: #409EFF;
          color: #409EFF;
          background: rgba(64,158,255,0.1);
        }
        
        img {
          width: 24px;
          height: 24px;
          margin-right: 8px;
          vertical-align: middle;
        }
      }
    }
  }
}

// 图片预览样式调整
:deep(.el-image-viewer__wrapper) {
  .el-image-viewer__btn {
    // 调整按钮颜色
    color: #fff;
    
    &.el-image-viewer__actions__inner {
      background-color: rgba(0,0,0,0.5);
    }
  }
  
  .el-image-viewer__canvas {
    // 调整图片显示
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style> 